import ButtonBase from '../button/ButtonBase';
import styles from './toggle-button.module.less';

// eslint-disable-next-line no-unused-vars
const ToggleButton = ({ className = '', type = 'button', selected = false, first = false, style = null, ...props }) => {
    return (
        <ButtonBase
            className={[styles.button, className, selected ? styles.selected : ''].join(' ')}
            type={type}
            {...props}
        />
    );
};

export default ToggleButton;
